<template>
  <div class='core'>
    <div class='layui-fluid'>
      <el-table
        border
        :data="pagerData.data"
        style="width: 100%"
        class="table-statistics-style"
      >
        <el-table-column
          prop="num"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="client_name"
          label="品牌"
          width="150">
        </el-table-column>
        <el-table-column
          prop="store_name"
          label="门店名称"
          width="300">
        </el-table-column>
        <el-table-column
          prop="store_manager"
          label="店长"
          width="120">
        </el-table-column>
        <el-table-column
          prop="address"
          label="地址"
          width="450">
        </el-table-column>
        <el-table-column
          prop="repair_type_ext_name"
          label="故障类型"
          width="180">
        </el-table-column>
        <el-table-column
          prop="problem_description"
          label="故障描述"
          width="450">
        </el-table-column>
        <el-table-column
          prop="repair_date"
          label="报修时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="approve_date"
          label="审核时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="signin_time"
          label="上门时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="check_desc"
          label="解决办法"
          width="150">
        </el-table-column>
        <el-table-column
          prop="signout_time"
          label="离场时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="acceptance_time"
          label="验收时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="income_amount"
          label="解决费用"
          width="120">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 20, 50]"
        :page-size="220"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagerData.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"


export default {
  name: 'detailStatistics',
  data () {
    return {
      pagerData: {
        data: [],
        total: 0
      },
      pageIndex: 0,
      pageSize: 10,
    }
  },
  props: {
    detailStatisticsList: {
      type: Array,
      default: ()=> {
        return [];
      }
    },
    rowCount: {
      type: Number,
      default: 0
    },
    endDate: {
      default: '',
      type: String
    },
    beginDate: {
      default: '',
      type: String
    },
  },
  mounted(){
    this.pagerData.data = this.detailStatisticsList
    this.pagerData.total = this.rowCount
  },
  watch: {
    detailStatisticsList(value) {
      this.pagerData.data = value
    },
    rowCount(value) {
      this.pagerData.total = value
    },
  },
  methods: {
    handleSizeChange(val) {
      // 每次切换条数  页数变为第一页
      this.pageSize = val
      this.pageIndex = 0
      // 调用父组件查询
      this.$emit('queryRepairDetailStatisticsList',this.beginDate, this.endDate, this.pageIndex, this.pageSize)
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      // 调用父组件查询
      this.$emit('queryRepairDetailStatisticsList',this.beginDate, this.endDate, this.pageIndex, this.pageSize)
    }
  }
}
</script>

<style scoped>
.table-statistics-style {
  height: calc(100vh - 286px);
}
</style>






// WEBPACK FOOTER //
// src/components/repairs/repairStatistics/detailStatistics.vue